<template>
  <jz-container v-if="bookmarkedCourses.length > 0" class="course-card-list">
    <jz-container class="section-header">
      {{ "dashboard.bookmarkCourses.title" | __ }}
    </jz-container>
    <jz-container class="container course-card-list-container">
      <router-link
        v-for="(course, idx) in bookmarkedCourses"
        class="course-card-link container-item"
        :key="idx"
        :to="{ name: courseDetailRouteName, params: { courseUuid: course.uuid } }"
      >
        <course-card :course="course" />
      </router-link>
    </jz-container>
  </jz-container>
</template>
<script>
import CourseCard from "@tt-app/components/course/CourseCard";
import { ROUTES, VUEX_CONTENT_ACTION_NAMES, VUEX_CONTENT_NAMESPACE } from "@tt-app/constants";
const { COURSE } = ROUTES;
const { BOOKMARKED_COURSES_REQUEST } = VUEX_CONTENT_ACTION_NAMES;
export default {
  name: "BookmarkedCoursesList",
  components: {
    CourseCard
  },
  computed: {
    bookmarkedCourses() {
      return this.$store.getters[`${VUEX_CONTENT_NAMESPACE}/bookmarkedCourses`];
    },
    courseDetailRouteName() {
      return COURSE.DETAILS.NAME;
    }
  },
  async created() {
    await this.$store.dispatch(`${VUEX_CONTENT_NAMESPACE}/${BOOKMARKED_COURSES_REQUEST}`, {});
  }
};
</script>
<style lang="scss">
.course-card-list-container {
  white-space: nowrap;
  overflow: auto;
  display: flex;

  .course-card-link {
    margin: $gutter / 2;
    margin-bottom: 0px;
  }

  .course-card {
    display: inline-block;
  }
}
.course-card-list-container a:first-of-type {
  margin-left: 0px;
}

// for displays with less width than desktop
@media only screen and (max-width: $min-desktop-width - 1) {
  .course-card-list-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .course-card-list-container::-webkit-scrollbar {
    display: none;
  }
}
</style>
